module.exports = __webpack_public_path__ + "img/tagline-black.d6c8b8cd.png";